/**
 * Broadcast ticker content.
 *
 * Cut back to three lines on 2026-07-31 (Ned): the strip was carrying six items
 * of build status and reading as a status console. It's brand furniture, so it
 * now says who we are, where to find us, and the one line worth repeating.
 *
 * INSTAGRAM_HANDLE confirmed 2026-07-31 (Ned, and checked against the live
 * profile: display name "KEV", bio carries the Knowledge. Edge. Value. tagline).
 * If it ever changes, change it here — the strip is the only place the handle
 * appears, and it's a link people will actually follow.
 *
 * Rules for anything added here:
 *   - No price, line, or implied probability. Ever. (guardrails §7)
 *   - No win rate or ROI. There's no public ledger yet. (§1.3)
 *   - No data-provider names.
 *   - Keep it to a handful of items. The strip is a wordmark, not a feed.
 */

export const INSTAGRAM_HANDLE = "@runitpastkev";
export const INSTAGRAM_URL = "https://www.instagram.com/runitpastkev/";

export const TICKER_ITEMS = [
  { text: INSTAGRAM_HANDLE, href: INSTAGRAM_URL },
  /* One of the AU mandated gambling-harm taglines. It belongs in the rotation
     precisely because it interrupts rather than sells. */
  "Imagine what you could be buying instead",
] as const;
